// @flow

import { documentCheckerActions } from './documentCheckerActionCreator';
import { REVIEW_STATUS } from '../documentCheckerConstants';

const initialState = {
  isLoading: false,
  isLoaded: false,
  consignmentData: [],
  filterData: [],
  clientFilterData: [],
  error: null,
  extractionLoading: false,
  extractionResult: null,
  activeExtractionCnote: null,
  bulkApproving: false
};

const documentCheckerReducer = (state = initialState, action) => {
  switch (action.type) {
    case documentCheckerActions.GET_DOCUMENT_CHECKER_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.SET_DOCUMENT_CHECKER_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.GET_FILTERS_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.SET_FILTERS_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.SET_LOADING_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.SET_CLIENT_FILTER_DATA: {
      return Object.assign({}, state, action.payload);
    }
    case documentCheckerActions.UPDATE_CONSIGNMENT_BY_INDEX: {
      const updatedConsignments = [...state.consignmentData];
      updatedConsignments[action.payload.index] = action.payload.consignment;
      return Object.assign({}, state, { consignmentData: updatedConsignments });
    }
    case documentCheckerActions.FETCH_EXTRACTION_RESULT_REQUEST:
      return {
        ...state,
        extractionLoading: true,
        extractionResult: null,
        activeExtractionCnote: action.meta?.cnote || null
      };
    case documentCheckerActions.FETCH_EXTRACTION_RESULT_SUCCESS:
      if (action.meta?.cnote !== state.activeExtractionCnote) {
        return state;
      }
      return {
        ...state,
        extractionLoading: false,
        extractionResult: action.payload
      };
    case documentCheckerActions.FETCH_EXTRACTION_RESULT_FAILURE:
      if (action.meta?.cnote !== state.activeExtractionCnote) {
        return state;
      }
      return {
        ...state,
        extractionLoading: false
      };
    case documentCheckerActions.BULK_APPROVE_REQUEST:
      return { ...state, bulkApproving: true };
    case documentCheckerActions.BULK_APPROVE_SUCCESS: {
      const approvedIds = action.meta?.ids || [];
      const updated = state.consignmentData.map(c =>
        approvedIds.includes(c.extractionResultId)
          ? { ...c, reviewStatus: REVIEW_STATUS.REVIEWED }
          : c
      );
      return { ...state, bulkApproving: false, consignmentData: updated };
    }
    case documentCheckerActions.BULK_APPROVE_FAILURE:
      return {
        ...state,
        bulkApproving: false
      };
    default: {
      return state;
    }
  }
};

export default documentCheckerReducer;
